import { CLOUDINARY_INTEL_BASE_URL } from "@utils/enum";

const UpgradePlanModal = ({ onClose, header = "", heading = "", subHeading = "", callBack, buttonText }) => (
  <div className="tw-fixed tw-inset-0 tw-z-[1000] tw-flex tw-items-center tw-justify-center tw-p-4">
    <div className="tw-absolute tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-transition-opacity" onClick={onClose} aria-hidden="true" />
    <div className="tw-relative tw-bg-white tw-rounded-lg tw-shadow-xl tw-w-full tw-max-w-lg tw-max-h-[90vh] tw-overflow-auto">
      <div className="tw-text-base tw-font-medium tw-pl-4 tw-py-3 tw-pr-12 tw-border-b tw-border-gray-200 tw-min-h-11">{header}</div>
      <div className="tw-h-[120px] tw-flex tw-items-center tw-justify-center tw-border-b tw-border-[#e9ecef] tw-bg-[url('https://res.cloudinary.com/drzta9shk/image/upload/v1684821201/intel/icons/orange-gradient-bg_x0rmp0.svg')] tw-bg-cover tw-bg-center">
        <div className="tw-flex tw-items-center tw-border-2 tw-border-white tw-rounded-xl tw-py-4 tw-px-12 tw-bg-white tw-bg-opacity-10 tw-backdrop-blur-sm">
          <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1684478309/intel/icons/Lightning-alt_t9mkjb.svg`} alt="Lightning" className="tw-w-6 tw-h-6" />
        </div>
      </div>
      <div className="tw-flex tw-flex-col tw-py-6 tw-px-6 tw-gap-6 tw-text-center tw-text-gray-900">
        <div className="tw-space-y-2">
          {heading && <div className="tw-font-semibold tw-text-base">{heading}</div>}
          {subHeading && <div className="tw-font-medium tw-text-sm tw-text-gray-600">{subHeading}</div>}
        </div>

        <div className="tw-flex tw-gap-3 tw-justify-center">
          <button onClick={onClose} className="tw-bg-white tw-text-gray-900 tw-border !tw-border-gray-200 hover:tw-bg-gray-50 tw-outline-none tw-rounded-lg tw-font-medium tw-px-6 tw-py-2 tw-transition-colors">
            Cancel
          </button>
          <button className="tw-bg-primary-purple-500 hover:tw-bg-primary-purple-600 tw-text-white tw-outline-none tw-border-none tw-rounded-lg tw-font-medium tw-px-6 tw-py-2 tw-transition-colors" onClick={callBack}>
            {buttonText || "Get In Touch"}
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default UpgradePlanModal;
